import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Input } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { ACTIVITY_ACTIONS_QUERY } from '../../../graphql.js'
import { handleGraphQLErrors } from '../../../utils.js'

export const ACTIVITY_ACTIONS = gql(ACTIVITY_ACTIONS_QUERY)

export default function ActivityActions({ handleChange,  defaultValue }) {
  console.log('ActivityActions rendered')

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: ACTIVITY_ACTIONS, fetchPolicy: 'cache-first' })
        if (data.activityActions) {
          const menuItems = [<option key={0} value={null}>All</option>]
          for (let item of data.activityActions) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [items])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (items) {
    return (
      <Input style={{ display: 'inline-block', width: 'auto' }} type="select" name="actionType" onChange={handleChange} defaultValue={defaultValue}>
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
